module.exports = __webpack_public_path__ + "img/false.858028c9.png";